import { css } from 'emotion';
import {
  actionGreen,
  gray11,
  gray4,
  gray7,
  notificationRed,
  weaveBlue,
  white,
} from '../../../styles/colors';

export const logoContainer = css`
  text-align: center;

  img {
    max-width: 100%;
    margin: auto;
  }
`;

export const input = css`
  margin: 8px auto;
  border-radius: 5px;
  border: 1px solid ${gray11};
  height: 40px;
  font-size: 16px;
  padding: 10px;
  width: 100%;
`;

export const container = css`
  width: 350px;
  padding: 16px;
  margin: auto;

  input {
    ${input}
  }

  button {
    display: block;
  }

  &,
  * {
    box-sizing: border-box;
  }
`;

export const requestLabel = css`
  margin-bottom: 16px;
  font-size: 12px;
`;

export const boldLabel = css`
  font-weight: bold;
  display: block;
`;

export const creditCardLabel = css`
  ${boldLabel}
  margin-top: 16px;
`;

export const amountRow = css`
  position: relative;
  display: flex;
  justify-content: space-between;

  & > div {
    display: inline-block;
    vertical-align: top;
    flex: 1 0 47.5%;

    &.attachmentBox {
      margin-left: 15px;
    }
  }

  & .amountSymbol {
    position: absolute;
    color: ${weaveBlue};
    top: 41px;
    left: 10px;
    font-size: 20px;
  }

  & .amountBox {
    color: ${weaveBlue};
    height: 50px;
    font-size: 20px;
    padding-left: 25px;
    margin-bottom: 0;
    width: 100%;

    ::placeholder {
      color: ${weaveBlue};
    }
  }
`;

export const attachmentLink = css`
  border: 1px solid ${gray11};
  border-radius: 5px;
  display: inline-block;
  flex-grow: 1;
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  color: ${gray4};
  padding-top: 5px;
  width: 100%;
  height: 50px;
  text-decoration: none;
`;

export const attachmentIcon = css`
  width: 25px;
  margin: 0 auto 5px;
  display: block;

  path {
    fill: ${actionGreen};
  }
`;

export const successIcon = css`
  width: 150px;
  margin: auto;

  path {
    fill: ${actionGreen};
  }
`;

export const errorIcon = css`
  width: 150px;
  margin: 20px auto;

  path {
    fill: ${notificationRed};
  }
`;

export const lockIcon = css`
  width: 20px;
  display: inline-block;
  margin-left: 25px;
  vertical-align: middle;

  path {
    fill: ${white};
  }
`;

export const stripeIcon = css`
  height: 20px;
  display: inline-block;
  margin-left: 25px;
  vertical-align: middle;
`;

export const cardField = css`
  ${input}
  padding-top: 12px;
`;

export const cardLogos = css`
  position: relative;
  top: -5px;

  img {
    height: 25px;
    border: 1px solid ${gray11};
    border-radius: 5px;
    margin-right: 2px;
  }
`;

export const emailField = css`
  &[type='email'] {
    margin-bottom: 0;
  }
`;

export const smallText = css`
  font-size: 10px;
  color: ${gray7};
`;

export const buttonContainer = css`
  width: 100%;
  text-align: center;
  margin-top: 20px;

  & > div {
    display: inline-flex;
    margin-top: 5px;

    a {
      color: ${weaveBlue};
      text-decoration: none;
      cursor: pointer;
      margin: auto;
    }
  }
`;

export const button = css`
  margin: 10px auto;
  background-color: ${weaveBlue};
  color: white;
  height: 50px;
  width: 100%;
  font-size: 16px;
  border-radius: 25px;
  cursor: pointer;
`;

export const resultMessage = css`
  text-align: center;
  color: ${gray7};
`;

export const modal = css`
  width: 300px;
  text-align: center;

  & .react-modal-card {
    padding: 10px;
  }

  & p {
    color: ${gray7};
  }
`;

export const confirmAmountLabel = css`
  color: ${weaveBlue};
  font-size: 36px;
  font-weight: bold;
`;

export const birthdate = css`
  margin-top: 25px;

  & > span {
    display: block;
    margin: 5px;
  }

  & input {
    width: 65px;
    margin: 10px;
    text-align: center;

    &::placeholder {
      color: ${gray11};
    }

    &:focus {
      border-color: ${weaveBlue};
    }
  }

  & > div > span {
    display: inline-block;
    width: 65px;
    text-align: center;
    margin: 0 10px 10px;
  }
`;

export const birthdateError = css`
  & input {
    border-color: ${notificationRed};
  }
`;

export const infoText = css`
  font-size: 15px;
`;

export const bold = css`
  font-weight: bold;
`;

export const securityBadges = css`
  margin-top: 35px;

  & img {
    margin: 0 10px;
    vertical-align: middle;
  }
`;

export const errorText = css`
  color: ${notificationRed};
`;

export const cardErrorText = css`
  font-size: 10px;
  color: ${notificationRed};
  position: relative;
  top: -10px;
`;

export const loaderContainer = css`
  ${container}
  height: 575px;
  display: flex;
`;

export const loader = css`
  width: 150px;
  display: block;
  margin: auto;
`;

export const paymentRequestButton = css`
  margin: 8px 0 16px;
  text-align: center;
`;
